import { Tooltip } from "@mui/material";
import { useEffect, useLayoutEffect } from "react";

const Information = (props) => {

    useLayoutEffect(()=>{
        if (document.querySelector(`.colSelector-0-${props.item.key}`)) {
            Object.entries(props.inputData[props.item.key]).map((item , index)=>{
                props.item.colInfo
                    ? document.querySelector(`.colSelector-${index}-${props.item.key}`).classList.add(`col-${props.item.colInfo}`)
                    : document.querySelector(`.colSelector-${index}-${props.item.key}`).classList.add(`col-${4}`)
            })
        }
    },[])

    return (
        <div className={`flex flex-col gap-y-[8px] col-span-full 560:col-span-${props.item.col}`} >
            <div>
                <Tooltip
                    title={
                        props.item.help === undefined ? (
                            ""
                        ) : (
                            <div className="text-right">
                                <h4 className="p-[5px] text-[12px]">{props.item.help.title}</h4>
                                <hr></hr>
                                <p className="p-[5px]">{props.item.help.body}</p>
                            </div>
                        )
                    }
                    placement="left-start"
                    arrow
                >
                    <label className="text-[14px] dark:text-[#D1D4C9] text-edit_input_label full sm:col-auto mb-1 mt-5 sm:mb-0 sm:mt-0">
                        {props.item.label}
                    </label>
                </Tooltip>
            </div>
            {props.inputData[props.item.key]&&<div className="bg-[#e2e4ff] grid grid-cols-1 560:grid-cols-12 gap-y-3 gap-x-6 p-4 rounded-lg ">
                {Object.entries(props.inputData[props.item.key]).map((item,index)=>(
                    <div className={`flex flex-wrap gap-1 colSelector-${index}-${props.item.key}`}><span className="text-gray-900">{item[0]}</span>:<span className="text-gray-700">{item[1]}</span></div>
                ))}
            </div>}
        </div>
    );
};

export default Information;
